import { Button } from "@/components/ui/Button";
import type { ButtonProps } from "@/components/ui/Button";
import type { AuftragMini } from "@/lib/orders";
import { useOrderWizard } from "@/pages/bestellungen/useOrderWizard";

export interface NewOrderButtonProps extends Omit<ButtonProps, "onClick"> {
  children?: ButtonProps["children"];
  /** Projekt vorauswählen, wenn aus einem Auftragskontext geöffnet. */
  auftrag?: AuftragMini;
}

/**
 * Öffnet den globalen Bestellungs-Assistenten von jeder React-Seite aus.
 */
export function NewOrderButton({
  children = "+ Neue Bestellung",
  auftrag,
  ...rest
}: NewOrderButtonProps) {
  const { openNew } = useOrderWizard();
  return (
    <Button {...rest} data-tour="bestellung-neu" onClick={() => openNew(auftrag ? { auftrag } : undefined)}>
      {children}
    </Button>
  );
}
